import React from "react";

const FlightCardSkeleton: React.FC = () => {
  return (
    <div className="flight-option-view mt-3 p-3 w-full border-[1px] group rounded-lg flex flex-col animate-pulse">
      <div className="flex flex-row h-full">
        {/* MAIN */}
        <div className="w-[75%] flex flex-col">
          <div className="w-full flex flex-row items-center">
            <div className="flex flex-col justify-center pt-1 pb-1 pl-3 pr-3 bg-gray-200 rounded-lg w-12 h-12"></div>
            <div className="flex flex-col ml-2 flex-grow">
              <div className="h-5 bg-gray-200 rounded w-1/3 mb-1"></div>
              <div className="h-4 bg-gray-200 rounded w-1/2"></div>
            </div>
            <div className="w-11 h-11 bg-gray-200 rounded-lg ml-auto"></div>
          </div>

          <div className="w-full bg-gray-200 mt-3 h-[1px]"></div>

          {/* FLIGHT INFO */}
          <div className="w-full flex flex-row justify-between px-2.5 items-center mt-4 mb-1">
            <div className="flex-none flex flex-col items-center">
              <div className="h-5 bg-gray-200 rounded w-16 mb-1"></div>
              <div className="h-4 bg-gray-200 rounded w-20"></div>
            </div>

            <div className="w-1/2 flex flex-col justify-center mt-2">
              <div className="h-4 bg-gray-200 rounded w-1/3 mx-auto mb-2"></div>
              <div className="flex flex-row items-center">
                <div className="bg-gray-300 rounded-full w-2 h-2"></div>
                <div className="h-[2px] bg-gray-200 flex-grow"></div>
                <div className="bg-gray-300 rounded-full w-4 h-4 mx-1"></div>
                <div className="h-[2px] bg-gray-200 flex-grow"></div>
                <div className="bg-gray-300 rounded-full w-2 h-2"></div>
              </div>
            </div>

            <div className="flex-none flex flex-col items-center">
              <div className="h-5 bg-gray-200 rounded w-16 mb-1"></div>
              <div className="h-4 bg-gray-200 rounded w-20"></div>
            </div>
          </div>
        </div>

        <div className="bg-gray-200 w-[1px] mx-2"></div>

        <div className="flex flex-col justify-center items-center w-[20%]">
          <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
          <div className="h-6 bg-gray-200 rounded w-1/2 mb-1"></div>
          <div className="h-4 bg-gray-200 rounded w-2/3 mb-3"></div>
          <div className="flex space-x-2">
            <div className="w-8 h-8 bg-gray-200 rounded-md"></div>
            <div className="w-8 h-8 bg-gray-200 rounded-md"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlightCardSkeleton;
